import { combineReducers } from 'redux';
import editor from './Editor/reducer';
import creator from './Creator/reducer';
import deletor from './Deletor/reducer';

const rootReducer = combineReducers({
  creator,
  editor,
  deletor,
});

export default rootReducer;
